import axios from "axios";
import { authFetch } from "../../api";
const endPoint = process.env.REACT_APP_API_ENDPOINT;

const endPoint2 = process.env.REACT_APP_API_SAP;

export const getMaritalStatus = async (data) => {
  const response = await axios.get(`${endPoint}maritial-status`, data);
  return response;
};

export const sourceofIncome = async (data) => {
  const response = await axios.get(`${endPoint}source-of-income`, data);
  return response;
};

export const relations = async (data) => {
  const response = await axios.get(`${endPoint}relations`, data);
  return response;
};

export const occupations = async (data) => {
  const response = await axios.get(`${endPoint2}get-all-occupations`, data);
  return response;
};

export const funds = async (data) => {
  const response = await axios.get(`${endPoint2}get-type-of-funds`, data);
  return response;
};

export const countries = async (data) => {
  const response = await axios.get(`${endPoint2}get-all-countries`, data);
  return response;
};

export const bankDetails = async (data) => {
  const response = await axios.post(`${endPoint2}get-bank-details`, data);
  return response;
};

export const calculateFunds = async (data) => {
  // const response = await authFetch(`funds/calculate-funds`, data);
  const response = authFetch(`funds/calculate-funds`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return response;
};

export const PreviousFunds = async (data) => {
  const response = await authFetch(`funds/show-previous-funds`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return response;
};

export const addSponsor = async (data) => {
  const response = await authFetch(`funds-planner/save-sponser-details`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return response;
};

export const deleteSponsor = async (data) => {
  const response = await authFetch(`funds-planner/delete-sponser-details`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return response;
};

export const addFundsPlan = async (data) => {
  const response = await authFetch(`funds-planner/add-sponser-funding-data`, {
    method: "POST",
    body: data,
  });
  return response;
};

export const deleteFundsPlan = async (data) => {
  const response = await authFetch(
    `funds-planner/delete-sponser-funding-data`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }
  );
  return response;
};

export const fetchSponsorsDetails = async (data) => {
  const response = await authFetch(`funds-planner/show-sponser-details`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return response;
};

export const fetchFundsPlanDetails = async (data) => {
  const response = await authFetch(`funds-planner/show-funding-details`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  return response;
};

export const fetchSponsorsPersonelDetails = async (data) => {
  const response = await authFetch(
    `funds-planner/show-sponser-personal-details`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }
  );
  return response;
};
